import React from 'react';
import { FieldNumber } from '../../types';
import { Map as LeafletMap } from 'leaflet'; // Import Leaflet Map type

// Define coordinates for each field (Latitude, Longitude)
const fieldCoordinates: { [key in FieldNumber]: [number, number] } = {
  1: [36.354371, -96.858428],
  2: [36.353060, -96.857045],
  3: [36.356216, -96.860794],
};

interface FieldSelectorProps {
  selectedField: FieldNumber;
  setSelectedField: React.Dispatch<React.SetStateAction<FieldNumber>>;
  mapInstance: LeafletMap | null; // Add map instance prop
}

const FieldSelector: React.FC<FieldSelectorProps> = ({ selectedField, setSelectedField, mapInstance }) => {
  const handleFieldClick = (field: FieldNumber) => {
    setSelectedField(field);
    if (mapInstance) {
      const coordinates = fieldCoordinates[field];
      mapInstance.flyTo(coordinates, 20);
    }
  };

  return (
    <div className="field-selector">
      <h3>Field</h3>
      {[1, 2, 3].map(field => (
        <button
          key={field}
          className={selectedField === field ? 'active' : ''}
          onClick={() => handleFieldClick(field as FieldNumber)} // Updated onClick handler
        >
          Field {field}
        </button>
      ))}
    </div>
  );
};

export default FieldSelector;
